import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {

  private imageCropVisibleState = new BehaviorSubject<{ Visible: boolean, FileEvent: any, OnImageCropped: (base64Image: string) => void }>(null);
  imageCropVisible: Observable<{ Visible: boolean, FileEvent: any, OnImageCropped: (base64Image: string) => void }> = this.imageCropVisibleState.asObservable();

  private appLoadingVisibleState = new BehaviorSubject<boolean>(false);
  appLoadingVisible: Observable<boolean> = this.appLoadingVisibleState.asObservable();


  constructor() { 
  }

  setImageCropModalVisible(visible: boolean, fileEvent?: any, onImageCropped?: (base64Image: string) => void) {
    this.imageCropVisibleState.next({Visible: visible, FileEvent: fileEvent, OnImageCropped: onImageCropped});
  }

  setAppLoadingVisible(visible: boolean) {
    this.appLoadingVisibleState.next(visible);
  }


  public showConfirmation(icon:'success' | 'error' | 'warning', title:string = 'Emin misiniz?', message:string, confirmCallback:any, cancelCallback?:any){
    
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
      showCancelButton: true,
      confirmButtonText: 'Onayla',
      cancelButtonText: 'İptal',
    })
    .then((result) => {
      if (result.value) {
        confirmCallback();
      } 
      else if (result.dismiss === Swal.DismissReason.cancel) {
        if(cancelCallback)
          cancelCallback();
      }
    });
  }

  public showNotification(icon:'success' | 'error' | 'warning', message:string, showConfirmationButton:boolean = false, title: string = '', confirmCallback?:any){
    
    if(title == null || title == ''){
      if(icon == 'success')
        title = 'Başarılı';
      else if(icon == 'error')
        title = 'Başarısız';
      else if(icon == 'warning')
        title = 'Uyarı';
    }
    
    var vTimer = showConfirmationButton ? null : 1500;

    Swal.fire({
      icon: icon,
      title: title,
      text: message,
      showConfirmButton: showConfirmationButton,
      confirmButtonText: 'Tamam',
      timer: vTimer
    })
    .then((result) => {
      if (result.value && confirmCallback) {
        confirmCallback();
      } 
      // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   if(cancelCallback)
      //     cancelCallback();
      // }
    });
  }

  public showResultNotification(result:ResultModel, showConfirmationButton:boolean = false, confirmCallback?:any){
    var title = '';
    var icon = result.Success == true ? 'success' : 'error';

    if(icon == 'success')
      title = 'Başarılı';
    else if(icon == 'error')
      title = 'Başarısız';
    else if(icon == 'warning')
      title = 'Uyarı';
    
    var vTimer = showConfirmationButton ? null : 1500;

    Swal.fire({
      icon: icon,
      title: title,
      text: result.Message,
      showConfirmButton: showConfirmationButton,
      confirmButtonText: 'Tamam',
      timer: vTimer
    })
    .then((result) => {
      if (result.value && confirmCallback) {
        confirmCallback();
      } 
      // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   if(cancelCallback)
      //     cancelCallback();
      // }
    });
  }

  /**
   * Parametre olarak gönderilen objeyi FormData nesnesine dönüştürür.
   * @param object FormData oluşturulacak nesne
   * @param form Değerlerinin kaydedileceği FormData nesnesi
   * @param namespace 
   * @param excludedProperties Herhangi bir prop hariç bırakılmak istenirse bu array içerisinde tanımlanması gereklidir
   * @param includedProperties Sadece belirlenen propların alınması istenirse bu array içerisinde tanımlanması gereklidir
   */
  public createFormData(object: Object, form?: FormData, namespace?: string, excludedProperties?: string[], includedProperties?: string[]): FormData {
    const formData = form || new FormData();
    for (let property in object) {

        if ((excludedProperties == null ? true : excludedProperties.indexOf(property) < 0) &&
          (includedProperties == null ? true : includedProperties.indexOf(property) > -1)) {
          
            if (!object.hasOwnProperty(property)) {
              continue;
            }
            const formKey = namespace ? `${namespace}[${property}]` : property;
            if (object[property] instanceof Date) {
                formData.append(formKey, object[property].toISOString());
            } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
                this.createFormData(object[property], formData, formKey);
            } else {
                formData.append(formKey, object[property]);
            }

        }
        
    }
    return formData;
}






  //Dinamik menü oluşturmak için gerekli

  /**
   * buildTree
   */
  // public buildTree(data: any[], childrenAttrName: string, idKey: string, parentIdKey: string, orderKey?: string) {
  //   //https://stackoverflow.com/a/55241491/4133449

  //   if (orderKey != null) {
  //     data.sort((a, b) => {
  //       if (a[orderKey] > b[orderKey]) {
  //         return 1;
  //       }
  //       else if (a[orderKey] < b[orderKey]) {
  //         return -1;
  //       }
  //       else {
  //         return 0;
  //       }
  //     });
  //   }

  //   const nest = (items: any[], id = null) =>
  //     items
  //       .filter(item => item[parentIdKey] === id)
  //       .map(item => ({ ...item, [childrenAttrName]: nest(items, item[idKey]) }));

  //   var tree = nest(data);

  //   return tree;
  // }

  // public buildTreeMap<T1, T2>(data: T1[], idKey: string, parentIdKey: string, mapFn: (element: T1, children: T2[]) => T2, orderKey?: string): T2[] {
  //   //https://stackoverflow.com/a/55241491/4133449

  //   if (orderKey != null) {
  //     data.sort((a, b) => {
  //       if (a[orderKey] > b[orderKey]) {
  //         return 1;
  //       }
  //       else if (a[orderKey] < b[orderKey]) {
  //         return -1;
  //       }
  //       else {
  //         return 0;
  //       }
  //     });
  //   }

  //   const nest = (items: T1[], id: string | number = null, ) =>
  //     items
  //       .filter(item => item[parentIdKey] === id)
  //       .map(item => {
  //         var children = nest(items, item[idKey]);
  //         var newObj = mapFn(item, children);
  //         return newObj;
  //       });

  //   var tree = nest(data);

  //   return tree;
  // }

}
